// assets
import { DashboardOutlined  } from '@ant-design/icons';
import Task from '@mui/icons-material/Task';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const Tasks = {
  id: 'tasks-management',
  title: 'Task Management',
  type: 'group',
  children: [
    {
      id: 'tasks-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/task-dashboard',
      icon: DashboardOutlined,
      breadcrumbs: true
    },
    {
      id: 'tasks',
      title: 'Tasks',
      type: 'item',
      url: '/task',
      icon: Task,
      breadcrumbs: true
    },


  ]
};

export default Tasks;
